'use strict';

import InterNACHI from 'shared/InterNACHI.js';
import browserslist_regex from 'shared/browserslist-regexp.js';
import bugsnagClient from '@bugsnag/js';

if (__PRODUCTION__ && browserslist_regex.test(navigator.userAgent)) {
	try {
		window.bugsnagClient = bugsnagClient;
		
		let started = false;
		const start = () => {
			if (! started) {
				started = true;
				bugsnagClient.start({
					apiKey: __BUGSNAG_KEY__,
					appVersion: process.env.CURRENT_ASSET_HASH,
				});
			}
		};
		
		// If we know we have a user, start bugsnag (otherwise we wait for a session to load)
		if ('logged_in_user' in window) {
			start();
		}
		
		InterNACHI.session.onLoaded(() => {
			const { id, email } = window.logged_in_user;
			start();
			window.bugsnagClient.setUser(id, email);
		});
	} catch (e) {
		console.error(`Unable to load Bugsnag: ${ e }`);
	}
}
